import CheckboxTnc from '../form/CheckboxTnc.js';

function PanelCheckboxTnc(props) {
   return (
    <div className="step">
        <CheckboxTnc tncList={props.tncList} passChildData={props.checkboxOnChange}></CheckboxTnc>
    </div>
   );
 }
 
export default PanelCheckboxTnc;